module.exports = __webpack_public_path__ + "static/media/phoneInteractionIcon-gray.98f45d9e.svg";